
/* injects from baggage-loader */

'use strict';

export default class IssuerOnboardingBackgroundCheckController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}
